<template>
    <div class="col-xl-3 col-md-6 box-col-50 des-xl-50">
        <div class="card social-shared">
            <div class="card-header pb-0">
                <h3>Top Social Media</h3>
            </div>
            <div class="card-body">
                <div class="table-responsive theme-scrollbar">
                    <table class="table table-bordernone">
                        <tbody>
                            <tr v-for="item in data" :key="item">
                                <td>
                                    <div class="d-flex">
                                        <div class="icon"><a :href="item.href" target="_blank"><img class="img-fluid"
                                                    :src="getImageUrl(item.img)" alt=""></a></div>
                                        <div class="flex-grow-1"><a :href="item.href" target="_blank">
                                                <h5>{{ item.social }}</h5>
                                                <p>Social Media </p>
                                            </a></div>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex"><i class="fa fa-arrow-up font-success me-2"></i>
                                        <h5>{{ item.total }}</h5>
                                    </div>
                                </td>
                                <td>
                                    <h5>{{ item.price }} </h5>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import getImage from "@/mixins/getImage"
export default {
    name: 'socialPage',
    mixins: [getImage],
    data() {
        return {
            data: [
                { href: "https://www.facebook.com/login", img: "dashboard/social-media/fb.png", social: "Facebook", total: "3.7%", price: "$24,000" },
                { href: "https://www.instagram.com/accounts/login/", img: "dashboard/social-media/insta.png", social: "Instagram", total: "3.7%", price: "$33,000" },
                { href: "https://www.twitter.com/login", img: "dashboard/social-media/twit.png", social: "Twitter", total: "7.6%", price: "$72,000" }
            ]
        }
    }
}
</script>